import { get } from "lodash";
import { Endpoints } from "../utilities/endpoints";
import ApiClient from "../utilities/http";

import { toastError } from "./formInputAction";
import { endSubmitting, isSubmitting } from "./loadActions";
import { ActuatorChannel, IActuator } from "../models/types";
import * as actionTypes from "../actionsTypes";
import { AxiosResponse } from "axios";
import { ILocation } from "../models/ILocation";


export const getActuators = () => {
    return new Promise(async (resolve, reject) => {
        ApiClient.post(Endpoints.GET_ACTUATORS)
            .then((res) => {
                if (get(res, 'status') === 200) {
                    const actuators: IActuator[] = get(res, 'data');
                    if (actuators !== undefined) {
                        resolve(actuators);
                    }
                } else {
                    reject(res);
                }
            })
            .catch(function (err: any) {
                toastError(err, 'Error fetching Actuators')
            });
    });
}

export const getActuatorLocations = () => {
    return (dispatch: any) => {
        dispatch(isSubmitting({
            submitButton: true,
        }));
        ApiClient.post(Endpoints.GET_ACTUATOR_LOCATIONS)
            .then((res) => {
                dispatch(endSubmitting({
                    submitButton: false,
                }));
                if (get(res, 'status') === 200) {
                    const locations: ILocation[] = get(res, 'data');
                    if (locations !== undefined) {
                        return dispatch({
                            type: actionTypes.ACTUATOR_LOCATION_LIST,
                            payload: locations
                        });
                    } else {
                        dispatch(toastError({}, 'No Locations found', 'Nope dude'));
                    }
                }
                return;
            })
            .catch(function (err: any) {
                toastError(err, 'Error fetching Locations')
            });
    }
}

export const getActuatorStatus = async (act: IActuator) => {
    return new Promise(async (resolve, reject) => {
        ApiClient.post(`${Endpoints.STATUS_ACTUATOR}/${act.id}`)
            .then((res: AxiosResponse) => {
                resolve(res.data as IActuator);
            })
            .catch((err) => {
                reject(err);
            })
    });
}

export async function toggleRelay(act: IActuator, chan: ActuatorChannel) {
    return new Promise(async (resolve, reject) => {
        ApiClient.post(`${Endpoints.TOGGLE_RELAY}/${act.id}/${chan.code}`)
            .then((res: AxiosResponse) => {
                resolve(res.data as IActuator);
            })
            .catch((err) => {
                reject(err);
            })
    });

}